import {
  CDropdown,
  CDropdownHeader,
  CDropdownMenu,
  CDropdownToggle
} from '@coreui/react-pro'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { ThemeContext } from 'src/context/ThemeContext'
import { ThemeBasedNotificationIcon } from './styledComponents'

const AppHeaderDropdownNotif = () => {
  const { theme } = useContext(ThemeContext)

  return (
    <CDropdown variant="nav-item" alignment="end">
      <CDropdownToggle custom caret={false} component={IconButton}>
        <IconButton>
          <ThemeBasedNotificationIcon sx={{ fontSize: '1.7rem' }} themeType={theme} />
        </IconButton>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownHeader className="bg-light dark:bg-bgDark">
          <strong>You have 0 notifications</strong>
        </CDropdownHeader>
        {/* <CDropdownItem>
          <CIcon icon={cilUserFollow} className="me-2 text-success" /> New user registered
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilUserUnfollow} className="me-2 text-danger" /> User deleted
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilChartPie} className="me-2 text-info" /> Sales report is ready
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilBasket} className="me-2 text-primary" /> New client
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilSpeedometer} className="me-2 text-warning" /> Server overloaded
        </CDropdownItem> */}
        {/* <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10">
          <strong>Server</strong>
        </CDropdownHeader>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>CPU Usage</b>
            </small>
          </div>
          <CProgress thin color="info-gradient" value={25} />
          <small className="text-medium-emphasis">348 Processes. 1/4 Cores.</small>
        </CDropdownItem>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>Memory Usage</b>
            </small>
          </div>
          <CProgress thin color="warning-gradient" value={70} />
          <small className="text-medium-emphasis">11444GB/16384MB</small>
        </CDropdownItem>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>SSD 1 Usage</b>
            </small>
          </div>
          <CProgress thin color="danger-gradient" value={90} />
          <small className="text-medium-emphasis">243GB/256GB</small>
        </CDropdownItem> */}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdownNotif
